<template>
<div class="col-xs-12">
  <div class="card float-e-margins">
    <div class="card-title">
        <h1>Overzicht</h1>
    </div>
    <div class="card-content no-padding">
      <vc-alert v-if="success" type="success"
         :timeout="4000">
      {{successMessage}}
      </vc-alert>
      <vc-alert v-if="error" type="danger" :dismissible="false">
         Er is een fout opgetreden!
      </vc-alert>
      <div class="table-responsive">
        <div class="card-title card-header form-horizontal">
          <label>Aantal advertenties: {{total}} </label>
          <div class="form-group">
            <label class="control-label col-sm-1" style="text-align:left;" for="filter">Filter op : </label>
            <div class="col-sm-4">
              <input type="text" class="form-control" id="filter" placeholder="Filter" v-model="filterKey">
            </div>
          </div>
          <a @click="filterOnIsOffered()">Aanbevolen producten</a>
        </div>
        <table class="table table-striped table-hover">
          <thead>
            <tr>
              <th v-for="(key, val) in columns">
                <a @click="sortBy(val)" class="arrow" :class="active: sortKey == column">
                  {{ key | capitalize }}
                </a>
              </th>
          </thead>
          <tbody>
            <tr v-for="product in products | filterBy filterKey | orderBy sortKey reverse">
              <td>
                <div class="pull-left">
                <img v-lazy="product.Photos[0].URL" style="height:100px;width:100px">
                </div>
              </td>
              <td>
                <p><strong>{{ product.Name }}</strong></p>
                <p style="white-space:pre-line;"><small>{{ product.Description }}</small></p>
              </td>
              <td width="10%">{{ product.Price | currencyDisplay }}</td>
              <td>
                <div class="ios">
                  <vui-toggle name="wifi" :checked.sync="product.Available" @change="setAvailable(product)"></vui-toggle>
                </div>
                <p v-if="product.Available" class="text-success">Beschikbaar</p>
                <p v-else class="text-danger">Verkocht</p>
              </td>
              <td width="10%">{{product.DateSubmitted}}</td>
              <td width="10%">
                <button type="button" class="btn btn-danger" @click="selectProduct(product, 'delete')">Verwijder</button>
                <br>
                <button v-if="!product.Offered" type="button" class="btn btn-success" @click="selectProduct(product, 'offer')">Aanbevolen</button>
                <button v-else type="button" class="btn btn-success" @click="selectProduct(product, 'offerOff')">UIT Aanbevolen</button>
                <br>
                <button type="button" class="btn btn-primary" v-link="{ name: 'AddProduct', params: { id: product.ProductId }}">Wijzig</button>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>
<vm-delete :callback.sync="remove" :show.sync="showdeltemodal"></vm-delete>
<vm-offer></vm-offer>
</template>
<script>
import store from '../../store'
import callbackalert from '../Common/CallbackAlert'
import toggle from '../Common/Toggle'
import deletemodal from '../Common/deleteSweetAlert'
import offermodal from '../Common/Modal'

export default {
  route: {
    canReuse: false
  },
  components: {
    'vc-alert': callbackalert,
    'vui-toggle': toggle,
    'vm-delete': deletemodal,
    'vm-offer': offermodal
  },
  data () {
    return {
      store: store,
      products: {},
      success: false,
      error: false,
      successMessage: 'Advertentie succesvol verwijderd!',
      columns: {
        '': 'Photos',
        'Naam': 'Name',
        'Prijs': 'Price',
        'Status': 'Available',
        'Datum': 'DatePlaced',
        ' ': 'Actions'
      },
      sortKey: '',
      reverse: 1,
      showdeltemodal: false,
      selectedProduct: null,
      filterKey: ''
    }
  },
  created () {
    this.getProducts()
  },
  methods: {
    getProducts: function () {
      $.ajax({
        type: 'GET',
        url: store.root + 'api/products',
        dataType: 'json',
        xhrFields: {
          withCredentials: true
        },
        success: function (response) {
          this.products = response
        }.bind(this)
      })
    },
    remove: function () {
      console.log('Verwijderd~!')
      $.ajax({
        type: 'DELETE',
        url: store.root + 'api/Products/' + this.selectedProduct.ProductId,
        beforeSend: function (xhr) {
          xhr.setRequestHeader('Authorization', 'Bearer ' + store.token)
        },
        xhrFields: {
          withCredentials: true
        }
      }).done(function () {
        this.success = true
        this.error = false
        this.products.$remove(this.selectedProduct)
        this.selectedProduct = null
        this.showdeltemodal = false
        console.log('Verwijderd~!')
      }.bind(this))
      .fail(function (response) {
        console.log(response)
        this.success = false
        this.error = true
      }.bind(this))
    },
    sortBy: function (sortKey) {
      this.reverse = (this.sortKey === sortKey) ? this.reverse * -1 : -1
      this.sortKey = sortKey
    },
    setAvailable: function (item) {
      $.ajax({
        type: 'PUT',
        url: store.root + 'api/Products/' + item.ProductId,
        data: item,
        beforeSend: function (xhr) {
          xhr.setRequestHeader('Authorization', 'Bearer ' + store.token)
        },
        xhrFields: {
          withCredentials: true
        }
      }).done(function () {
        console.log('change Available succesfully done!')
      })
      .fail(function (response) {
        console.log(response)
      })
    },
    selectProduct: function (val, type) {
      this.selectedProduct = val
      console.log(type)
      if (type === 'delete') {
        this.showdeltemodal = true
      }
      if (type === 'offer') {
        val.Offered = true
        this.setAvailable(val)
      }
      if (type === 'offerOff') {
        val.Offered = false
        this.setAvailable(val)
      }
    },
    filterOnIsOffered () {
      this.sortBy('Offered')
    }
  },
  computed: {
    total: function () {
      return this.products.length
    }
  }
}
</script>


// WEBPACK FOOTER //
// dashboard.vue?4d2fc084